<template>
  <div class="dropdown">
    <button type="button" class="dropdown-toggle btn btn-outline-success" @click.stop.prevent="dropdownToggle">Add new</button>
    <div class="menu">
      <a href="#" class="dropdown-item" @click.prevent="addNewModal">Add Schedule Template</a>
      <a href="#" class="dropdown-item" @click.prevent="cloneModal">Clone Schedule Template</a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    config: Object
  },
  methods: {
    dropdownToggle(e) {
      e.currentTarget.nextElementSibling.classList.toggle('show')
    },
    addNewModal(e) {
      e.currentTarget.parentElement.classList.toggle('show')
      this.$emitter.emit('Modal', {
        name: 'schedule-template.create',
        data: {},
        $el: null
      })
    },
    cloneModal(e) {
      e.currentTarget.parentElement.classList.toggle('show')
      this.$emitter.emit('Modal', {
        name: 'schedule-template.clone',
        data: {},
        $el: null
      })
    }
  }
}
</script>
